var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgOrder = function SvgOrder(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 15 15",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8 3.9H13L9.3 0v3.5c0 .2.2.4.5.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 5.2c-.5 0-1.2-.7-1.2-1.2V0H2.9c-.5 0-.7.4-.7 1v13.1c0 .5.2.9.7.9h9.2c.5 0 .9-.4.9-.9V5.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m9.5 7.4-2.7 2.9L5.3 9l-.9 1.2 2.4 2.2.1.1 3.6-3.9.1-.1z",
    style: {
      fill: "#fff"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOrder);
export default ForwardRef;